import React, { PureComponent } from 'react';
import _ from 'lodash';
import './NodeValue.css';

import Value from './Value'
import { Result } from 'src/types/result';
import { Cursor } from 'src/lib/Cursor';
import * as Model from '../types/document'
import { Stack } from 'src/types/stack';
import { evaluateNode } from 'src/model/evaluate';

// import TwoSvg from './TwoSvg'
// import Two from 'two.js'

// Displays a value the way you'd expect it to be displayed inside a NodeBox

class NodeValue extends PureComponent<{
  result: Result<any>
  width: number,
  height: number,
  setActiveIndex?: (activeIndex: number | string) => void,
  activeIndex?: number | string,
  blockC: Cursor<Model.Block>,
  nodeId?: Model.NodeId,  // won't be present in, e.g., inactive settings
  stack: Stack,
}> {

  render() {
    const { result, setActiveIndex, blockC, nodeId, stack } = this.props
    let { activeIndex } = this.props

    // fix activeIndex...
    if (activeIndex === 0) {
      if (result.type === 'value' && !(result.value instanceof Array)) {
        activeIndex = _.keys(result.value)[0]
      }
    }

    let contents

    if (!result) {
      contents = undefined // "???"
    } else if (result.type === "error") {
      contents = <span style={{color: "red"}}>{result.error.message}</span>
    // } else if (result.value && result.value.isDiagram) {  // todo: detect diagrams?
    //   const size = width - 10  // TODO: uniform vs non-uniform
    //   // const scaled = Diagram.scale(result.value, size / 20)
    //   contents = <Diagram width={size} height={size} diagram={result.value} />
    } else {
      contents = <Value value={result.value} activeIndex={activeIndex} top={true}
                        onElementMouseOver={setActiveIndex}
                        blockC={blockC} nodeId={nodeId} stack={stack}
                        path={[]}/>
    }

    return (
      <div className="NodeValue">
        { contents }
      </div>
    );
  }
}

export default NodeValue



// WEBPACK FOOTER //
// ./src/view/NodeValue.tsx